import { render } from "./UserInitialsIcon.vue?vue&type=template&id=ea6beb74&ts=true"
import script from "./UserInitialsIcon.vue?vue&type=script&lang=ts"
export * from "./UserInitialsIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__